import { setFieldCache } from '../set-field-cache/index.tsx';
import type { SetPrefetchedProps } from './types.tsx';

export const setPrefetched = (props: SetPrefetchedProps) =>
	setFieldCache({
		...props,
	});
